import React from "react";
import styles from "../../../styles/charts/chartStyle.module.css";
import ReactApexChart from "react-apexcharts";
import { isSmallScreen, titleStyler, toShortNumber } from "../../../lib/util";
import { ApexOptions } from "apexcharts";

const BoxPlotChart = (props: any) => {
  let { axisTitleStyle, axisLabelStyle } = titleStyler();

  let smallScreen = isSmallScreen();

  // let showXLabel = true;
  if (props.hideXLabel && smallScreen) {
    // showXLabel = false;
  }
  const title = props.title;

  let options = {
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: "xLabel",
            headerValue: "yLabel",
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      boxPlot: {
        // making it empty so that it will use the default colors from theme pallete
        colors: [],
      },
    },
    // title: {
    //   text: props.title,
    //   align: "center",
    //   style: chartTitleStyle,
    // },
    xaxis: {
      labels: {
        show: true,
        rotate: 0,
        rotateAlways: false,
        hideOverlappingLabels: false,
        trim: true,
        style: axisLabelStyle,
      },
      title: {
        text: props.xLabel,
        offsetX: 0,
        // offsetY: showXLabel ? 95 : 70,
        offsetY: 85,
        style: axisTitleStyle,
      },
    },
    yaxis: {
      tickAmount: 7,
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0,
        formatter: toShortNumber,
        style: axisLabelStyle,
      },
      title: {
        text: props.yLabel,
        offsetY: 0,
        offsetX: 5,
        style: axisTitleStyle,
      },
    },
    noData: {
      text: `${props.loading ? "Loading..." : "Please Select a Category"}`,
      align: "center" as "center",
      verticalAlign: "middle" as "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        <ReactApexChart
          className={styles.the_chart}
          options={options as unknown as ApexOptions}
          series={props.chartData}
          type="boxPlot"
        />
      </div>
    </>
  );
};

export default BoxPlotChart;
